import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { StepImageUploadOnFeedFragmentDoc } from '../../media/step-image-uploads/__generated__/step-image-upload.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateFormFieldMutationVariables = Types.Exact<{
  contentId: Types.Scalars['ID']['input'];
  input: Types.FormFieldInput;
}>;


export type UpdateFormFieldMutation = { __typename?: 'RootMutationType', updateFormField?: { __typename?: 'ContentResult', content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null, chapters?: Array<{ __typename?: 'NarrationChapter', id: string, title?: string | null, slidePageNumber?: number | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null }> | null } | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null } | null, formFields?: Array<{ __typename?: 'AudioField' } | { __typename?: 'EmailField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'LongTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'PhoneField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'ShortTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'VideoField' } | null> | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const UpdateFormFieldDocument = gql`
    mutation updateFormField($contentId: ID!, $input: FormFieldInput!) {
  updateFormField(contentId: $contentId, input: $input) {
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      oembedResult
      providerName
      videoContain
      video {
        id
        rawUrl
        transcodedUrl
        previewUrl
        streamUrl
        gifUrl
        gifWithIconUrl
      }
      image {
        ...StepImageUploadOnFeed
      }
      narration {
        id
        title
        type
        video {
          id
          rawUrl
          transcodedUrl
          previewUrl
          streamUrl
          gifUrl
          gifWithIconUrl
        }
        chapters {
          id
          title
          slidePageNumber
          video {
            id
            rawUrl
            transcodedUrl
            previewUrl
            streamUrl
            gifUrl
            gifWithIconUrl
          }
        }
      }
      file {
        id
        name
        size
        pageCount
        mimeType
        fileUrl
      }
      formFields {
        ... on EmailField {
          id
          key
          label
          isRequired
          isHidden
        }
        ... on ShortTextField {
          id
          key
          label
          isRequired
          isHidden
        }
        ... on LongTextField {
          id
          key
          label
          isRequired
          isHidden
        }
        ... on PhoneField {
          id
          key
          label
          isRequired
          isHidden
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${StepImageUploadOnFeedFragmentDoc}`;
export type UpdateFormFieldMutationFn = Apollo.MutationFunction<UpdateFormFieldMutation, UpdateFormFieldMutationVariables>;

/**
 * __useUpdateFormFieldMutation__
 *
 * To run a mutation, you first call `useUpdateFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormFieldMutation, { data, loading, error }] = useUpdateFormFieldMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormFieldMutation, UpdateFormFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormFieldMutation, UpdateFormFieldMutationVariables>(UpdateFormFieldDocument, options);
      }
export type UpdateFormFieldMutationHookResult = ReturnType<typeof useUpdateFormFieldMutation>;
export type UpdateFormFieldMutationResult = Apollo.MutationResult<UpdateFormFieldMutation>;
export type UpdateFormFieldMutationOptions = Apollo.BaseMutationOptions<UpdateFormFieldMutation, UpdateFormFieldMutationVariables>;